// extracted by mini-css-extract-plugin
export default {"wrapper":"sectionHeader_wrapper__d4-Ri common_wrapper__NGpQt","sectionTitle":"sectionHeader_sectionTitle__AU0cx","title":"sectionHeader_title__TGHXd"};